import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string, boolean } from "yup";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import NoImageFound from "../../assets/images/No-Image-found.png";
import Select from "react-select";

const validationSchema = object().shape({
  first_name: string().required("First Name is required"),
  alternative_contact_number: string()
    .matches(/^\d{10}$/, "Alternative contact number must be exactly 10 digits")
    .required("Alternative contact number is required"),
  email: string().email("Invalid email").required("Email is required"),
  // business_name: string().required("Business Name is required"),
  business_name: string().when("business_type", {
    is: (val) =>
      val !== "doctor" && val !== "hospital" && val !== "lab_diagonastic",
    then: (schema) => schema.required("Business Name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  business_type: string().required("Business Type is required"),
  door_no: string().required("Door No is required"),
  street: string().required("Street is required"),
  area: string().required("Area is required"),
  city: string().required("City is required"),
  state: string().required("State is required"),
  pincode: string().required("Pincode is required"),
  ryder_zone: string().required("Ryder Zone is required"),

  //businees type is doctor

  designation: string().when("business_type", {
    is: "doctor",
    then: (schema) => schema.required("Designation is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // doctor
  clinic_name: string().when("business_type", {
    is: "doctor",
    then: (schema) => schema.required("clinic name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // hospital
  hospital_name: string().when("business_type", {
    is: "hospital",
    then: (schema) => schema.required("hospital name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  chief_doctor_name: string().when("business_type", {
    is: "hospital",
    then: (schema) => schema.required("chief doctor name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // lab diagonastic

  diagnostic_name: string().when("business_type", {
    is: "lab_diagonastic",
    then: (schema) => schema.required("diagnostic name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

const DOCUMENT_LABELS = {
  form_20a: "Form 20",
  form_21a: "Form 21",
  gst_certificate: "GST",
  aadhaar: "Aadhaar",
  pan_card: "PAN Card",
  business_outlet_image: "Business Outlet Image",
  pharmacy_certificate: "Pharmacy Certificate",
  food_license: "Food License",
  labour_license: "Labour License",
  clinic_image: "Clinic Image",
};

const formatDate = (dateStr) => {
  if (!dateStr) return "--";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-GB"); // dd/mm/yyyy format
};

export const RetailerEditPersonal = ({ id }) => {
  const [retailer, setRetailer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [docMap, setDocMap] = useState({});
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  // const [imageUrl, setImageUrl] = useState("");
  const [previewFile, setPreviewFile] = useState({
    url: "",
    type: "", // "image" | "pdf" | "unsupported"
  });

  const [toggleModalOpenVerification, setToggleModalOpenVerification] =
    useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);
  // reupload
  const [reuploadMode, setReuploadMode] = useState({});

  const navigate = useNavigate();

  console.log(id);

  const VERIFIED_FIELD_MAP = {
    form_20a: "form20a_verified",
    form_21a: "form21a_verified",
    gst_certificate: "gst_verified",
    aadhaar: "aadhaar_verified",
    pan_card: "pan_verified",
    business_outlet_image: "outlet_verified",
    pharmacy_certificate: "pharmacy_certificate_verified",
    food_license: "food_license_verified",
    labour_license: "labour_license_verified",
    clinic_image: "clinic_image_verified",
    hospital_image: "hospital_image_verified",
    drug_license: "drug_license_verified",
    udyam_certificate: "udyam_certificate_verified",
  };

  const renameFile = (file, username, key) => {
    const ext = file.name.split(".").pop();
    const newName = `${username}_${key}.${ext}`;
    return new File([file], newName, { type: file.type });
  };

  const [ryderZoneList, setRyderZoneList] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);

  const fetchRyderZone = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/admin/ryder-zone-list/");

      if (res.data.status === "success") {
        const data = res.data.data || [];

        setRyderZoneList(data);

        // Extract unique cities
        const uniqueCities = [...new Set(data.map((item) => item.city))];

        // Convert for react-select
        const formattedCities = uniqueCities.map((city) => ({
          value: city,
          label: city,
        }));

        setCityOptions(formattedCities);
      }
    } catch (err) {
      console.error("Error fetching RyderZone data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRyderZone();
  }, []);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      alternative_contact_number: "",
      door_no: "",
      street: "",
      area: "",
      city: "",
      state: "",
      pincode: "",
      ryder_zone: "",
      business_name: "",
      business_type: "",
      bank_name: "",
      bank_account_number: "",
      razorpay_account_id: "",
      ifsc_code: "",

      // doctor
      doctor_registration_number: "",
      designation: "",
      clinic_name: "",

      // hospital
      hospital_name: "",
      chief_doctor_name: "",
      chief_doctor_number: "",

      // lab
      lab_registration_number: "",
      gst_number: "",
      tin_number: "",
      diagnostic_name: "",

      // verification flags
      form20a_verified: false,
      form21a_verified: false,
      gst_verified: false,
      aadhaar_verified: false,
      pan_verified: false,
      outlet_verified: false,
      pharmacy_certificate_verified: false,
      food_license_verified: false,
      labour_license_verified: false,
      clinic_image_verified: false,
      hospital_image_verified: false,
      drug_license_verified: false,
      udyam_certificate_verified: false,

      is_registered: false,
      is_verified: false,
      is_active: false,

      // 🔥 FILE FIELDS (MANDATORY)
      form_20a_file: null,
      form_21a_file: null,
      gst_certificate_file: null,
      aadhaar_file: null,
      pan_card_file: null,
      business_outlet_image_file: null,
      pharmacy_certificate_file: null,
      food_license_file: null,
      labour_license_file: null,
      clinic_image_file: null,
      hospital_image_file: null,
      drug_license_file: null,
      udyam_certificate_file: null,
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      //  BLOCK IF HOSPITAL IMAGE EXISTS BUT NOT VERIFIED
      // if (
      //   docMap?.hospital_image?.file_path &&
      //   !values.hospital_image_verified
      // ) {
      //   formik.setFieldError(
      //     "hospital_image_verified",
      //     "Please verify the hospital image before submitting",
      //   );

      //   formik.setFieldTouched("hospital_image_verified", true, false);

      //   setLoading(false);
      //   return;
      // }
      // BLOCK IF HOSTPITAL IMAGE AND IS_VERIFIED NOT EXIT
      const hasExistingHospitalImage = Boolean(
        docMap?.hospital_image?.file_path,
      );

      const hasNewHospitalImage = Boolean(values.hospital_image_file);
      // hospital image
      if (
        values.business_type === "hospital" &&
        !hasExistingHospitalImage &&
        !hasNewHospitalImage
      ) {
        formik.setFieldError(
          "hospital_image_file",
          "Hospital image is required",
        );

        formik.setFieldTouched("hospital_image_file", true, false);

        setLoading(false);
        return;
      }
      // is verfied
      if (
        values.business_type === "hospital" &&
        (hasExistingHospitalImage || hasNewHospitalImage) &&
        !values.hospital_image_verified
      ) {
        formik.setFieldError(
          "hospital_image_verified",
          "Please verify the hospital image before submitting",
        );

        formik.setFieldTouched("hospital_image_verified", true, false);

        setLoading(false);
        return;
      }
      //  BLOCK IF CLINIC IMAGE EXISTS BUT NOT VERIFIED
      // if (docMap?.clinic_image?.file_path && !values.clinic_image_verified) {
      //   formik.setFieldError(
      //     "clinic_image_verified",
      //     "Please verify the clinic image before submitting",
      //   );

      //   formik.setFieldTouched("clinic_image_verified", true, false);

      //   setLoading(false);
      //   return;
      // }
      
      // BLOCK IF CLINIC IMAGE AND IS_VERIFIED NOT EXIT
      const hasExistingClinicImage = Boolean(docMap?.clinic_image?.file_path);

      const hasNewClinicImage = Boolean(values.clinic_image_file);
      //clinic image
      if (
        values.business_type === "doctor" &&
        !hasExistingClinicImage &&
        !hasNewClinicImage
      ) {
        formik.setFieldError("clinic_image_file", "Clinic image is required");

        formik.setFieldTouched("clinic_image_file", true, false);

        setLoading(false);
        return;
      }
      // is verfied
      if (
        values.business_type === "doctor" &&
        (hasExistingClinicImage || hasNewClinicImage) &&
        !values.clinic_image_verified
      ) {
        formik.setFieldError(
          "clinic_image_verified",
          "Please verify the clinic image before submitting",
        );

        formik.setFieldTouched("clinic_image_verified", true, false);

        setLoading(false);
        return;
      }
      //  BLOCK IF BUSINESS OUTLET IMAGE EXISTS BUT NOT VERIFIED
      // if (docMap?.business_outlet_image?.file_path && !values.outlet_verified) {
      //   formik.setFieldError(
      //     "outlet_verified",
      //     "Please verify the business outlet image before submitting",
      //   );

      //   formik.setFieldTouched("outlet_verified", true, false);

      //   setLoading(false);
      //   return;
      // }

      // BLOCK IF BUSINESS OUTLET IMAGE AND IS_VERIFIED NOT EXIT
      const hasExistingOutletImage = Boolean(
        docMap?.business_outlet_image?.file_path,
      );

      const hasNewOutletImage = Boolean(values.business_outlet_image_file);
      // business outlet image
      if (
        values.business_type === "medical_store" &&
        !hasExistingOutletImage &&
        !hasNewOutletImage
      ) {
        formik.setFieldError(
          "business_outlet_image_file",
          "Business outlet image is required",
        );

        formik.setFieldTouched("business_outlet_image_file", true, false);

        setLoading(false);
        return;
      }
      // is verfied
      if (
        values.business_type === "medical_store" &&
        (hasExistingOutletImage || hasNewOutletImage) &&
        !values.outlet_verified
      ) {
        formik.setFieldError(
          "outlet_verified",
          "Please verify the business outlet image before submitting",
        );

        formik.setFieldTouched("outlet_verified", true, false);

        setLoading(false);
        return;
      }

      try {
        const docKeys = [
          "form_20a",
          "form_21a",
          "gst_certificate",
          "aadhaar",
          "pan_card",
          "business_outlet_image",
          "pharmacy_certificate",
          "food_license",
          "labour_license",
          "clinic_image",
          "hospital_image",
          "drug_license",
          "udyam_certificate",
        ];

        const uploadedDocs = docKeys.filter((key) => values[`${key}_file`]);
        const hasFileUpload = uploadedDocs.length > 0;

        /**
         * ===============================
         * CASE 1 — NO FILE UPLOAD
         * ===============================
         */
        if (!hasFileUpload) {
          const businessDocsPayload = docKeys
            .filter((key) => docMap[key]?.businessdoc_id)
            .map((key) => ({
              businessdoc_id: docMap[key].businessdoc_id,
              is_verified: values[VERIFIED_FIELD_MAP[key]] ?? false,
            }));

          const payload = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            alternative_contact_number: values.alternative_contact_number,
            door_no: values.door_no,
            street: values.street,
            area: values.area,
            city: values.city,
            state: values.state,
            pincode: values.pincode,
            ryder_zone: values.ryder_zone,
            bank_name: values.bank_name,
            bank_account_number: values.bank_account_number,
            razorpay_account_id: values.razorpay_account_id,
            ifsc_code: values.ifsc_code,

            retailers: {
              doctor_registration_number: values.doctor_registration_number,
              designation: values.designation,
              clinic_name: values.clinic_name,
              hospital_name: values.hospital_name,
              chief_doctor_name: values.chief_doctor_name,
              chief_doctor_number: values.chief_doctor_number,
              lab_registration_number: values.lab_registration_number,
              gst_number: values.gst_number,
              tin_number: values.tin_number,
              diagnostic_name: values.diagnostic_name,
              business_name: values.business_name,
              business_type: values.business_type,
            },

            is_registered: values.is_registered,
            is_verified: values.is_verified,
            is_active: values.is_active,
            business_docs: businessDocsPayload,
          };

          await axiosInstance.put(`/admin/retailer-list/${id}/`, payload);
          toast.success("Retailer updated successfully!");
          navigate("/manage-retailer");
          return;
        }

        /**
         * ===============================
         * CASE 2 — SEQUENTIAL FILE UPLOAD
         * ===============================
         */
        for (let i = 0; i < uploadedDocs.length; i++) {
          const key = uploadedDocs[i];
          const existingDoc = docMap[key];
          const originalFile = values[`${key}_file`];

          // 🔹 Rename file
          const renamedFile = renameFile(
            originalFile,
            values.username || retailer?.username,
            key,
          );

          const formData = new FormData();

          if (existingDoc?.businessdoc_id) {
            formData.append(
              "business_docs[0][businessdoc_id]",
              existingDoc.businessdoc_id,
            );
          }

          formData.append("business_docs[0][file_name]", key);
          formData.append("business_docs[0][file_path]", renamedFile);

          const patchRes = await axiosInstance.patch(
            `/admin/retailer-list/${id}/`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          );

          if (patchRes.data.status !== "success") {
            toast.error(`Failed to upload ${key}`);
            return;
          }
        }

        /**
         * ===============================
         * CASE 3 — FINAL PUT AFTER FILES
         * ===============================
         */
        const filteredDocs = docKeys
          .filter((key) => docMap[key]?.businessdoc_id)
          .map((key) => ({
            businessdoc_id: docMap[key].businessdoc_id,
            is_verified: values[VERIFIED_FIELD_MAP[key]] ?? false,
          }));

        const finalPayload = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          alternative_contact_number: values.alternative_contact_number,
          door_no: values.door_no,
          street: values.street,
          area: values.area,
          city: values.city,
          state: values.state,
          pincode: values.pincode,
          ryder_zone: values.ryder_zone,
          bank_name: values.bank_name,
          bank_account_number: values.bank_account_number,
          razorpay_account_id: values.razorpay_account_id,
          ifsc_code: values.ifsc_code,

          retailers: {
            doctor_registration_number: values.doctor_registration_number,
            designation: values.designation,
            clinic_name: values.clinic_name,
            hospital_name: values.hospital_name,
            chief_doctor_name: values.chief_doctor_name,
            chief_doctor_number: values.chief_doctor_number,
            lab_registration_number: values.lab_registration_number,
            gst_number: values.gst_number,
            tin_number: values.tin_number,
            diagnostic_name: values.diagnostic_name,
            business_name: values.business_name,
            business_type: values.business_type,
          },

          is_registered: values.is_registered,
          is_verified: values.is_verified,
          is_active: values.is_active,
          business_docs: filteredDocs,
        };

        await axiosInstance.put(`/admin/retailer-list/${id}/`, finalPayload);
        toast.success("Retailer updated successfully!");
        navigate("/manage-retailer");
      } catch (err) {
        console.error(err);
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    navigate("/manage-retailer");
  };

  // useEffect(() => {
  //   const fetchRetailerDetails = async () => {
  //     try {
  //       const res = await axiosInstance.get(`/admin/retailer-list/${id}`);
  //       if (res.data.status === "success" && res.data.data) {
  //         const data = res.data.data;

  //         const docs = data.business_docs || [];
  //         const newDocMap = {};
  //         const docValues = {};

  //         docs.forEach((doc) => {
  //           newDocMap[doc.file_name] = doc;
  //           docValues[doc.file_name + "_verified"] = doc.is_verified; // ✅ keeps existing verified status
  //         });

  //         setDocMap(newDocMap);

  //         // formik.setValues(initialFormValues);

  //         // Set Formik values
  //         formik.setValues({
  //           ...formik.initialValues,
  //           ...docValues,
  //           first_name: data.first_name || "",
  //           last_name: data.last_name || "",
  //           email: data.email || "",
  //           mobile_no: data.mobile_no || "",
  //           alternative_contact_number: data.alternative_contact_number || "",
  //           door_no: data.door_no || "",
  //           street: data.street || "",
  //           area: data.area || "",
  //           city: data.city || "",
  //           state: data.state || "",
  //           pincode: data.pincode || "",
  //           business_name: data.retailers?.business_name || "",
  //           business_type: data.retailers?.business_type || "",
  //           bank_name: data.bank_name || "",
  //           bank_account_number: data.bank_account_number || "",
  //           razorpay_account_id: data.razorpay_account_id || "",
  //           ifsc_code: data.ifsc_code || "",
  //           //doctor
  //           doctor_registration_number:
  //             data.retailers?.doctor_registration_number || "",
  //           designation: data.retailers?.designation || "",
  //           clinic_name: data.retailers?.clinic_name || "",
  //           // hospital
  //           hospital_name: data.retailers?.hospital_name || "",
  //           chief_doctor_name: data.retailers?.chief_doctor_name || "",
  //           chief_doctor_number: data.retailers?.chief_doctor_number || "",

  //           //lab diagonastic
  //           lab_registration_number:
  //             data.retailers?.lab_registration_number || "",
  //           gst_number: data.retailers?.gst_number || "",
  //           tin_number: data.retailers?.tin_number || "",
  //           diagnostic_name: data.retailers?.diagnostic_name || "",
  //           is_registered: data.is_registered,
  //           is_verified: data.is_verified,
  //           is_active: data.is_active,
  //         });
  //       } else {
  //         toast.error("Failed to load Retailer details.");
  //         setDocMap({});
  //       }
  //     } catch (err) {
  //       console.error("Error fetching Retailer data:", err);
  //       toast.error("Something went wrong while loading Retailer data.");
  //       setDocMap({});
  //     }
  //   };

  //   fetchRetailerDetails();
  // }, [id]);

  // console.log("Data retailer new add variable", retailer);

  useEffect(() => {
    const fetchRetailerDetails = async () => {
      try {
        const res = await axiosInstance.get(`/admin/retailer-list/${id}`);

        if (res.data.status === "success" && res.data.data) {
          const data = res.data.data;
          setRetailer(data);

          const docs = data.business_docs || [];
          const newDocMap = {};
          const verifiedValues = {};

          // -------------------------------
          // Build docMap + verification flags
          // -------------------------------
          docs.forEach((doc) => {
            newDocMap[doc.file_name] = doc;

            const verifiedField = VERIFIED_FIELD_MAP[doc.file_name];
            if (verifiedField) {
              verifiedValues[verifiedField] = Boolean(doc.is_verified);
            }
          });

          setDocMap(newDocMap);

          // -------------------------------
          // Set Formik values SAFELY
          // -------------------------------
          formik.setValues((prev) => ({
            ...prev,

            // personal info
            first_name: data.first_name || "",
            last_name: data.last_name || "",
            email: data.email || "",
            alternative_contact_number: data.alternative_contact_number || "",
            door_no: data.door_no || "",
            street: data.street || "",
            area: data.area || "",
            city: data.city || "",
            state: data.state || "",
            pincode: data.pincode || "",
            ryder_zone: data.ryder_zone || "",
            mobile_no: data.mobile_no || "",

            // bank
            bank_name: data.bank_name || "",
            bank_account_number: data.bank_account_number || "",
            razorpay_account_id: data.razorpay_account_id || "",
            ifsc_code: data.ifsc_code || "",

            // retailer info
            business_name: data.retailers?.business_name || "",
            business_type: data.retailers?.business_type || "",

            // doctor
            doctor_registration_number:
              data.retailers?.doctor_registration_number || "",
            designation: data.retailers?.designation || "",
            clinic_name: data.retailers?.clinic_name || "",

            // hospital
            hospital_name: data.retailers?.hospital_name || "",
            chief_doctor_name: data.retailers?.chief_doctor_name || "",
            chief_doctor_number: data.retailers?.chief_doctor_number || "",

            // lab
            lab_registration_number:
              data.retailers?.lab_registration_number || "",
            gst_number: data.retailers?.gst_number || "",
            tin_number: data.retailers?.tin_number || "",
            diagnostic_name: data.retailers?.diagnostic_name || "",

            // account flags
            is_registered: Boolean(data.is_registered),
            is_verified: Boolean(data.is_verified),
            is_active: Boolean(data.is_active),

            // ✅ VERIFIED CHECKBOX VALUES (CRITICAL FIX)
            ...verifiedValues,
          }));
        } else {
          toast.error("Failed to load Retailer details.");
          setDocMap({});
        }
      } catch (err) {
        console.error("Error fetching Retailer data:", err);
        toast.error("Something went wrong while loading Retailer data.");
        setDocMap({});
      }
    };

    fetchRetailerDetails();
  }, [id]);

  const handleToggleStatus = () => {
    if (!toggleTarget) return;
    formik.setFieldValue(toggleTarget.field, !toggleTarget.currentValue);
    setToggleModalOpenVerification(false);
    setToggleTarget(null);
  };

  if (loading) return <p>Loading retailer details...</p>;
  // if (!retailer) return <p>No retailer data found.</p>;

  // const renderDocumentFields = () => {
  //   const entries = Object.entries(docMap);
  //   const left = [];
  //   const right = [];

  //   entries.forEach(([key, doc], index) => {
  //     const element = (
  //       <div key={key} className="editWholesaler-field">
  //         <label>{DOCUMENT_LABELS[key] || key}</label>
  //         <div>
  //           <button
  //             type="button"
  //             className="preview-button"
  //             onClick={() => {
  //               setImageUrl(doc.file_path || "");
  //               setToggleModalOpen(true);
  //             }}
  //           >
  //             Preview the document
  //           </button>

  //           {doc.license_expiry_date && (
  //             <div className="licenseExpiryDate mt-2">
  //               <p>
  //                 <b>{DOCUMENT_LABELS[key] || key} Expiry Date</b>:{" "}
  //                 {formatDate(doc.license_expiry_date)}
  //               </p>
  //             </div>
  //           )}

  //           <div className="mt-2 d-flex align-items-center gap-2">
  //             <input
  //               type="checkbox"
  //               name={key + "_verified"}
  //               checked={formik.values[key + "_verified"] || false}
  //               onChange={formik.handleChange}
  //             />
  //             <span className="textIsverified">Is Verified</span>
  //           </div>
  //         </div>
  //       </div>
  //     );

  //     index % 2 === 0 ? left.push(element) : right.push(element);
  //   });

  //   return (
  //     <div className="general-container">
  //       <div className="general-left">{left}</div>
  //       <div className="general-right">{right}</div>
  //     </div>
  //   );
  // };

  // const renderDocumentFields = () => {
  //   const entries = Object.entries(docMap);
  //   const left = [];
  //   const right = [];

  //   // Define mandatory document(s) by business type
  //   let requiredDocs = [];
  //   const businessType = formik.values.business_type;

  //   if (businessType === "medical_store") {
  //     requiredDocs = ["business_outlet_image"];
  //   } else if (businessType === "lab_diagonastic") {
  //     requiredDocs = ["clinic_image"];
  //   } else if (businessType === "hospital") {
  //     requiredDocs = ["hospital_image"];
  //   } else if (businessType === "doctor") {
  //     requiredDocs = ["clinic_image"];
  //   }

  //   entries.forEach(([key, doc], index) => {
  //     const isRequired = requiredDocs.includes(key);
  //     const isVerified = formik.values[key + "_verified"] || false;

  //     const element = (
  //       <div key={key} className="editWholesaler-field">
  //         <label>
  //           {isRequired && <span className="text-danger">*</span>}{" "}
  //           {DOCUMENT_LABELS[key] || key}
  //         </label>

  //         <div>
  //           <button
  //             type="button"
  //             className="preview-button"
  //             onClick={() => {
  //               setImageUrl(doc.file_path || "");
  //               setToggleModalOpen(true);
  //             }}
  //           >
  //             Preview the document
  //           </button>

  //           {doc.license_expiry_date && (
  //             <div className="licenseExpiryDate mt-2">
  //               <p>
  //                 <b>{DOCUMENT_LABELS[key] || key} Expiry Date</b>:{" "}
  //                 {formatDate(doc.license_expiry_date)}
  //               </p>
  //             </div>
  //           )}

  //           <div className="mt-2 d-flex align-items-center gap-2">
  //             <input
  //               type="checkbox"
  //               name={key + "_verified"}
  //               checked={isVerified}
  //               onChange={formik.handleChange}
  //             />
  //             <span className="textIsverified">Is Verified</span>
  //           </div>

  //           {/* Show error if mandatory doc is not verified */}
  //           {/* {isRequired && !isVerified && (
  //             <div className="text-danger small mt-1">
  //               {DOCUMENT_LABELS[key] || key} is mandatory for{" "}
  //               {businessType.replace("_", " ")}.
  //             </div>
  //           )} */}

  //           {/* Show mandatory doc message only after user submits */}
  //           {formik.submitCount > 0 && isRequired && !isVerified && (
  //             <div className="text-danger small mt-1">
  //               {DOCUMENT_LABELS[key] || key} is mandatory for{" "}
  //               {businessType.replace("_", " ")}.
  //             </div>
  //           )}
  //         </div>
  //       </div>
  //     );

  //     index % 2 === 0 ? left.push(element) : right.push(element);
  //   });

  //   return (
  //     <div className="general-container">
  //       <div className="general-left">{left}</div>
  //       <div className="general-right">{right}</div>
  //     </div>
  //   );
  // };

  const getFileType = (url = "") => {
    const extension = url.split(".").pop()?.toLowerCase();

    if (["jpg", "jpeg", "png", "webp"].includes(extension)) return "image";
    if (extension === "pdf") return "pdf";

    return "unsupported";
  };

  const openPreview = (filePath) => {
    if (!filePath) return;

    setPreviewFile({
      url: filePath,
      type: getFileType(filePath),
    });

    setToggleModalOpen(true);
  };

  return (
    <>
      <div className="editWholesaler-container">
        <form onSubmit={formik.handleSubmit}>
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">General Information</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>First Name
                </label>
                <div>
                  <input
                    type="text"
                    name="first_name"
                    placeholder="Enter Your First Name"
                    value={formik.values.first_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.first_name && formik.errors.first_name && (
                    <div className="text-danger">
                      {formik.errors.first_name}
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="editWholesaler-field">
            <label>
              <span className="text-danger">*</span>Create Password
            </label>
            <div>
              <input type="text" placeholder="Enter New Password" />
            </div>
          </div> */}

              <div className="editWholesaler-field">
                <label>Mobile Number</label>
                <div>
                  <input
                    type="tel"
                    name="mobile_no"
                    placeholder="Enter Your mobile_no"
                    value={formik.values.mobile_no}
                    onBlur={formik.handleBlur}
                    maxLength={10}
                    disabled
                  />
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Alternative Contact
                  Number
                </label>
                <div>
                  <input
                    type="tel"
                    name="alternative_contact_number"
                    placeholder="Enter Your Alternative Contact Number"
                    value={formik.values.alternative_contact_number}
                    onChange={(e) => {
                      const input = e.target.value;
                      // Only allow digits and max 10 characters
                      if (/^\d{0,10}$/.test(input)) {
                        formik.setFieldValue(
                          "alternative_contact_number",
                          input,
                        );
                      }
                    }}
                    onBlur={formik.handleBlur}
                    maxLength={10}
                  />
                  {formik.touched.alternative_contact_number &&
                    formik.errors.alternative_contact_number && (
                      <div className="text-danger">
                        {formik.errors.alternative_contact_number}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="general-right">
              <div className="editWholesaler-field">
                <label>Last Name</label>
                <div>
                  <input
                    type="text"
                    name="last_name"
                    placeholder="Enter Your Last Name"
                    value={formik.values.last_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Email id
                </label>
                <div>
                  <input
                    type="text"
                    name="email"
                    placeholder="Enter Your email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-danger">{formik.errors.email}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* address */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Address</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Door No/House No
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Door No/House No"
                    name="door_no"
                    value={formik.values.door_no}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.door_no && formik.errors.door_no && (
                    <div className="text-danger">{formik.errors.door_no}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Area/Locality
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Area"
                    name="area"
                    value={formik.values.area}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.area && formik.errors.area && (
                    <div className="text-danger">{formik.errors.area}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>City/Town
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your City"
                    name="city"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.city && formik.errors.city && (
                    <div className="text-danger">{formik.errors.city}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Ryder Zone
                </label>
                <Select
                  options={cityOptions}
                  value={
                    cityOptions.find(
                      (option) => option.value === formik.values.ryder_zone,
                    ) || null
                  }
                  onChange={(option) => {
                    formik.setFieldValue("ryder_zone", option?.value || "");
                  }}
                  onBlur={() => formik.setFieldTouched("ryder_zone", true)}
                  placeholder="Search Ryder Zone"
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "35px",
                      height: "35px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "35px",
                      padding: "0 8px",
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: "35px",
                    }),
                  }}
                />
                {formik.touched.ryder_zone && formik.errors.ryder_zone && (
                  <div className="text-danger">{formik.errors.ryder_zone}</div>
                )}
              </div>
            </div>
            <div className="general-right">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Street
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Street"
                    name="street"
                    value={formik.values.street}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.street && formik.errors.street && (
                    <div className="text-danger">{formik.errors.street}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>State
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your State"
                    name="state"
                    value={formik.values.state}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.state && formik.errors.state && (
                    <div className="text-danger">{formik.errors.state}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Pincode
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Pincode"
                    name="pincode"
                    value={formik.values.pincode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.pincode && formik.errors.pincode && (
                    <div className="text-danger">{formik.errors.pincode}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Business Information */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Business Information</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Business Type
                </label>
                <div>
                  {/* <input
                    type="text"
                    placeholder="Enter Your Business Type "
                    name="business_type"
                    value={formik.values.business_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.business_type &&
                    formik.errors.business_type && (
                      <div className="text-danger">
                        {formik.errors.business_type}
                      </div>
                    )} */}

                  <select
                    name="business_type"
                    // value={formik.values.business_type}
                    // onChange={formik.handleChange}
                    value={formik.values.business_type}
                    onChange={(e) =>
                      formik.setFieldValue("business_type", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    className="form-control"
                  >
                    <option value="">-- Select Business Type --</option>
                    <option value="doctor">Doctor</option>
                    <option value="hospital">Hospital</option>
                    <option value="medical_store">Chemist/Medical Store</option>
                    <option value="lab_diagonastic">Lab Diagnostic</option>
                  </select>

                  {formik.touched.business_type &&
                    formik.errors.business_type && (
                      <div className="text-danger">
                        {formik.errors.business_type}
                      </div>
                    )}
                </div>
              </div>

              {formik.values.business_type === "doctor" ? (
                // Show Designation
                <div className="editWholesaler-field">
                  <label>
                    <span className="text-danger">*</span>Designation
                  </label>
                  <input
                    type="text"
                    name="designation"
                    value={formik.values.designation}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.designation && formik.errors.designation && (
                    <div className="text-danger">
                      {formik.errors.designation}
                    </div>
                  )}
                </div>
              ) : formik.values.business_type === "hospital" ? (
                // Show Chief Doctor Name
                <div className="editWholesaler-field">
                  <label>
                    <span className="text-danger">*</span> Chief Doctor Name
                  </label>
                  <input
                    type="text"
                    name="chief_doctor_name"
                    value={formik.values.chief_doctor_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.chief_doctor_name &&
                    formik.errors.chief_doctor_name && (
                      <div className="text-danger">
                        {formik.errors.chief_doctor_name}
                      </div>
                    )}
                </div>
              ) : formik.values.business_type === "lab_diagonastic" ? (
                // Show Lab Registration Number
                <div className="editWholesaler-field">
                  <label>Lab Registration Number</label>
                  <input
                    type="text"
                    name="lab_registration_number"
                    value={formik.values.lab_registration_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              ) : null}

              {formik.values.business_type === "lab_diagonastic" ? (
                // TIN Number
                <div className="editWholesaler-field">
                  <label>TIN Number</label>
                  <input
                    type="text"
                    name="tin_number"
                    value={formik.values.tin_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              ) : null}
            </div>

            <div className="general-right">
              {formik.values.business_type === "doctor" ? (
                // Doctor field
                <div className="editWholesaler-field">
                  <label>Doctor Registration Number</label>
                  <input
                    type="text"
                    name="doctor_registration_number"
                    value={formik.values.doctor_registration_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              ) : formik.values.business_type === "hospital" ? (
                // Hospital field
                <div className="editWholesaler-field">
                  <label>
                    <span className="text-danger">*</span> Hospital Name
                  </label>
                  <input
                    type="text"
                    name="hospital_name"
                    value={formik.values.hospital_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.hospital_name &&
                    formik.errors.hospital_name && (
                      <div className="text-danger">
                        {formik.errors.hospital_name}
                      </div>
                    )}
                </div>
              ) : formik.values.business_type === "lab_diagonastic" ? (
                // diagnostic name field
                <div className="editWholesaler-field">
                  <label>
                    <span className="text-danger">*</span>Diagnostic Name
                  </label>
                  <input
                    type="text"
                    name="diagnostic_name"
                    value={formik.values.diagnostic_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.diagnostic_name &&
                    formik.errors.diagnostic_name && (
                      <div className="text-danger">
                        {formik.errors.diagnostic_name}
                      </div>
                    )}
                </div>
              ) : (
                // Business field
                <div className="editWholesaler-field">
                  <label>
                    <span className="text-danger">*</span> Business Name
                  </label>
                  <input
                    type="text"
                    name="business_name"
                    value={formik.values.business_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.business_name &&
                    formik.errors.business_name && (
                      <div className="text-danger">
                        {formik.errors.business_name}
                      </div>
                    )}
                </div>
              )}

              {formik.values.business_type === "doctor" ? (
                // Show clinic name
                <div className="editWholesaler-field">
                  <label>
                    <span className="text-danger">*</span> Clinic Name
                  </label>
                  <input
                    type="text"
                    name="clinic_name"
                    value={formik.values.clinic_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.clinic_name && formik.errors.clinic_name && (
                    <div className="text-danger">
                      {formik.errors.clinic_name}
                    </div>
                  )}
                </div>
              ) : formik.values.business_type === "hospital" ? (
                // Show Chief Doctor Number
                <div className="editWholesaler-field">
                  <label>Chief Doctor Number</label>
                  <input
                    type="text"
                    name="chief_doctor_number"
                    value={formik.values.chief_doctor_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              ) : formik.values.business_type === "lab_diagonastic" ? (
                // gst number
                <div className="editWholesaler-field">
                  <label>GST Number</label>
                  <input
                    type="text"
                    name="gst_number"
                    value={formik.values.gst_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              ) : null}
            </div>
          </div>
          {/* KYC Information */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">KYC:</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field mt-4">
                <label>Bank Name</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Bank Name"
                    name="bank_name"
                    value={formik.values.bank_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>IFSC Code</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter IFSC Code"
                    name="ifsc_code"
                    value={formik.values.ifsc_code}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className="general-right">
              <div className="editWholesaler-field mt-4">
                <label>Bank Account Number</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Bank Account Number"
                    name="bank_account_number"
                    value={formik.values.bank_account_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>Razorpay Account ID</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your razorpay account id"
                    name="razorpay_account_id"
                    value={formik.values.razorpay_account_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Business Documents */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Business Documents</span>
          </div>

          {formik.values.business_type === "lab_diagonastic" ? (
            <>
              <div className="general-container-no-documents">
                <p className="no-documents-text">No Documents are present</p>
              </div>
            </>
          ) : null}
          {/* <div>{renderDocumentFields()}</div> */}
          <div className="general-container">
            <div className="general-left">
              {formik.values.business_type === "medical_store" ? (
                <>
                  {/* ================= Form 20A ================= */}
                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>Form 20A</label>

                      {docMap["form_20a"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["form_20a"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              form_20a: !prev.form_20a,
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    {docMap["form_20a"]?.file_path &&
                    !reuploadMode["form_20a"] ? (
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          // onClick={() => {
                          //   setImageUrl(docMap["form_20a"].file_path);
                          //   setToggleModalOpen(true);
                          // }}
                          onClick={() =>
                            openPreview(docMap["form_20a"]?.file_path)
                          }
                        >
                          Preview the document
                        </button>

                        <div className="mt-2 d-flex align-items-center gap-2">
                          <input
                            type="checkbox"
                            name="form20a_verified"
                            checked={formik.values.form20a_verified}
                            onChange={formik.handleChange}
                          />
                          <span className="textIsverified">Is Verified</span>
                        </div>

                        <div className="licenseExpiryDate">
                          <p>
                            <b>License Expiry Date</b>:{" "}
                            {docMap["form_20a"].license_expiry_date
                              ? formatDate(
                                  docMap["form_20a"].license_expiry_date,
                                )
                              : "--"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="file"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "form_20a_file",
                            e.target.files[0],
                          )
                        }
                      />
                    )}
                  </div>

                  {/* ================= GST ================= */}
                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>GST</label>

                      {docMap["gst_certificate"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["gst_certificate"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              gst_certificate: !prev.gst_certificate,
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    {docMap["gst_certificate"]?.file_path &&
                    !reuploadMode["gst_certificate"] ? (
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          // onClick={() => {
                          //   setImageUrl(docMap["gst_certificate"].file_path);
                          //   setToggleModalOpen(true);
                          // }}
                          onClick={() =>
                            openPreview(docMap["gst_certificate"]?.file_path)
                          }
                        >
                          Preview the document
                        </button>

                        <div className="mt-2 d-flex align-items-center gap-2">
                          <input
                            type="checkbox"
                            name="gst_verified"
                            checked={formik.values.gst_verified}
                            onChange={formik.handleChange}
                          />
                          <span className="textIsverified">Is Verified</span>
                        </div>

                        <div className="licenseExpiryDate">
                          <p>
                            <b>License Expiry Date</b>:{" "}
                            {docMap["gst_certificate"].license_expiry_date
                              ? formatDate(
                                  docMap["gst_certificate"].license_expiry_date,
                                )
                              : "--"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="file"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "gst_certificate_file",
                            e.target.files[0],
                          )
                        }
                      />
                    )}
                  </div>

                  {/* ================= Pharmacy Certificate ================= */}
                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>Pharmacy Certificate</label>

                      {docMap["pharmacy_certificate"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["pharmacy_certificate"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              pharmacy_certificate: !prev.pharmacy_certificate,
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    {docMap["pharmacy_certificate"]?.file_path &&
                    !reuploadMode["pharmacy_certificate"] ? (
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          // onClick={() => {
                          //   setImageUrl(
                          //     docMap["pharmacy_certificate"].file_path
                          //   );
                          //   setToggleModalOpen(true);
                          // }}
                          onClick={() =>
                            openPreview(
                              docMap["pharmacy_certificate"]?.file_path,
                            )
                          }
                        >
                          Preview the document
                        </button>

                        <div className="mt-2 d-flex align-items-center gap-2">
                          <input
                            type="checkbox"
                            name="pharmacy_certificate_verified"
                            checked={
                              formik.values.pharmacy_certificate_verified
                            }
                            onChange={formik.handleChange}
                          />
                          <span className="textIsverified">Is Verified</span>
                        </div>

                        <div className="licenseExpiryDate">
                          <p>
                            <b>License Expiry Date</b>:{" "}
                            {docMap["pharmacy_certificate"].license_expiry_date
                              ? formatDate(
                                  docMap["pharmacy_certificate"]
                                    .license_expiry_date,
                                )
                              : "--"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="file"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "pharmacy_certificate_file",
                            e.target.files[0],
                          )
                        }
                      />
                    )}
                  </div>

                  {/* ================= Food License ================= */}
                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>Food License</label>

                      {docMap["food_license"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["food_license"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              food_license: !prev.food_license,
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    {docMap["food_license"]?.file_path &&
                    !reuploadMode["food_license"] ? (
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          // onClick={() => {
                          //   setImageUrl(docMap["food_license"].file_path);
                          //   setToggleModalOpen(true);
                          // }}
                          onClick={() =>
                            openPreview(docMap["food_license"]?.file_path)
                          }
                        >
                          Preview the document
                        </button>

                        <div className="mt-2 d-flex align-items-center gap-2">
                          <input
                            type="checkbox"
                            name="food_license_verified"
                            checked={formik.values.food_license_verified}
                            onChange={formik.handleChange}
                          />
                          <span className="textIsverified">Is Verified</span>
                        </div>

                        <div className="licenseExpiryDate">
                          <p>
                            <b>License Expiry Date</b>:{" "}
                            {docMap["food_license"].license_expiry_date
                              ? formatDate(
                                  docMap["food_license"].license_expiry_date,
                                )
                              : "--"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="file"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "food_license_file",
                            e.target.files[0],
                          )
                        }
                      />
                    )}
                  </div>
                </>
              ) : null}

              {/* Business Type doctor */}
              {formik.values.business_type === "doctor" ? (
                <>
                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>
                        <span className="text-danger">*</span>Clinic Image
                      </label>

                      {docMap["clinic_image"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["clinic_image"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              clinic_image: !prev.clinic_image,
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    {docMap["clinic_image"]?.file_path &&
                    !reuploadMode["clinic_image"] ? (
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          // onClick={() => {
                          //   setImageUrl(docMap["clinic_image"].file_path);
                          //   setToggleModalOpen(true);
                          // }}
                          onClick={() =>
                            openPreview(docMap["clinic_image"]?.file_path)
                          }
                        >
                          Preview the document
                        </button>

                        <div className="licenseExpiryDate">
                          <p>
                            <b>License Expiry Date</b>:{" "}
                            {docMap["clinic_image"].license_expiry_date
                              ? formatDate(
                                  docMap["clinic_image"].license_expiry_date,
                                )
                              : "--"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <>
                        <input
                          type="file"
                          onChange={(e) =>
                            formik.setFieldValue(
                              "clinic_image_file",
                              e.target.files[0],
                            )
                          }
                        />
                        {/* {formik.touched.clinic_image_file &&
                        formik.errors.clinic_image_file && (
                          <div className="text-danger">
                            {formik.errors.clinic_image_file}
                          </div>
                        )} */}
                        {(formik.touched.clinic_image_file ||
                          formik.submitCount > 0) &&
                          formik.errors.clinic_image_file && (
                            <div className="text-danger">
                              {formik.errors.clinic_image_file}
                            </div>
                          )}
                      </>
                    )}
                    {/* CHECKBOX FOR BOTH EXISTING AND NEWLY SELECTED IMAGE */}
                    <div className="mt-2 ">
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="clinic_image_verified"
                          checked={formik.values.clinic_image_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>
                      <div>
                        {(formik.touched.clinic_image_verified ||
                          formik.submitCount > 0) &&
                          formik.errors.clinic_image_verified && (
                            <div className="text-danger mt-1">
                              {formik.errors.clinic_image_verified}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}

              {/* Business Type hospital */}
              {formik.values.business_type === "hospital" ? (
                <>
                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>Drug License</label>

                      {docMap["drug_license"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["drug_license"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              drug_license: !prev.drug_license,
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    {docMap["drug_license"]?.file_path &&
                    !reuploadMode["drug_license"] ? (
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          // onClick={() => {
                          //   setImageUrl(docMap["drug_license"].file_path);
                          //   setToggleModalOpen(true);
                          // }}
                          onClick={() =>
                            openPreview(docMap["drug_license"]?.file_path)
                          }
                        >
                          Preview the document
                        </button>

                        <div className="mt-2 d-flex align-items-center gap-2">
                          <input
                            type="checkbox"
                            name="drug_license_verified"
                            checked={formik.values.drug_license_verified}
                            onChange={formik.handleChange}
                          />
                          <span className="textIsverified">Is Verified</span>
                        </div>

                        <div className="licenseExpiryDate">
                          <p>
                            <b>License Expiry Date</b>:{" "}
                            {docMap["drug_license"].license_expiry_date
                              ? formatDate(
                                  docMap["drug_license"].license_expiry_date,
                                )
                              : "--"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="file"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "drug_license_file",
                            e.target.files[0],
                          )
                        }
                      />
                    )}
                  </div>

                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>
                        <span className="text-danger">*</span>Hospital Image
                      </label>

                      {docMap["hospital_image"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["hospital_image"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              hospital_image: !prev.hospital_image,
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    {docMap["hospital_image"]?.file_path &&
                    !reuploadMode["hospital_image"] ? (
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          // onClick={() => {
                          //   setImageUrl(docMap["hospital_image"].file_path);
                          //   setToggleModalOpen(true);
                          // }}
                          onClick={() =>
                            openPreview(docMap["hospital_image"]?.file_path)
                          }
                        >
                          Preview the document
                        </button>

                        <div className="licenseExpiryDate">
                          <p>
                            <b>License Expiry Date</b>:{" "}
                            {docMap["hospital_image"].license_expiry_date
                              ? formatDate(
                                  docMap["hospital_image"].license_expiry_date,
                                )
                              : "--"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <>
                        <input
                          type="file"
                          onChange={(e) =>
                            formik.setFieldValue(
                              "hospital_image_file",
                              e.target.files[0],
                            )
                          }
                        />
                        {formik.touched.hospital_image_file &&
                          formik.errors.hospital_image_file && (
                            <div className="text-danger">
                              {formik.errors.hospital_image_file}
                            </div>
                          )}
                      </>
                    )}

                    {/* CHECKBOX FOR BOTH EXISTING AND NEWLY SELECTED IMAGE */}
                    <div className="mt-2 ">
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="hospital_image_verified"
                          checked={formik.values.hospital_image_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>
                      <div>
                        {(formik.touched.hospital_image_verified ||
                          formik.submitCount > 0) &&
                          formik.errors.hospital_image_verified && (
                            <div className="text-danger mt-1">
                              {formik.errors.hospital_image_verified}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>

            <div className="general-right">
              {formik.values.business_type === "medical_store" ? (
                <>
                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>Form 21A</label>

                      {docMap["form_21a"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["form_21a"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              form_21a: !prev["form_21a"],
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    <div>
                      {docMap["form_21a"]?.file_path &&
                      !reuploadMode["form_21a"] ? (
                        <div>
                          <button
                            type="button"
                            className="preview-button"
                            // onClick={() => {
                            //   setImageUrl(docMap["form_21a"].file_path);
                            //   setToggleModalOpen(true);
                            // }}
                            onClick={() =>
                              openPreview(docMap["form_21a"]?.file_path)
                            }
                          >
                            Preview the document
                          </button>

                          <div className="mt-2 d-flex align-items-center gap-2">
                            <input
                              type="checkbox"
                              name="form21a_verified"
                              checked={formik.values.form21a_verified}
                              onChange={formik.handleChange}
                            />
                            <span className="textIsverified">Is Verified</span>
                          </div>

                          <div className="licenseExpiryDate">
                            <p>
                              <b>License Expiry Date</b>:{" "}
                              {docMap["form_21a"].license_expiry_date
                                ? formatDate(
                                    docMap["form_21a"].license_expiry_date,
                                  )
                                : "--"}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <input
                          type="file"
                          onChange={(e) =>
                            formik.setFieldValue(
                              "form_21a_file",
                              e.target.files[0],
                            )
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>
                        <span className="text-danger">*</span>Business Outlet
                        Image
                      </label>

                      {docMap["business_outlet_image"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["business_outlet_image"]
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              business_outlet_image:
                                !prev["business_outlet_image"],
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    <div>
                      {docMap["business_outlet_image"]?.file_path &&
                      !reuploadMode["business_outlet_image"] ? (
                        <div>
                          <button
                            type="button"
                            className="preview-button"
                            // onClick={() => {
                            //   setImageUrl(
                            //     docMap["business_outlet_image"].file_path
                            //   );
                            //   setToggleModalOpen(true);
                            // }}
                            onClick={() =>
                              openPreview(
                                docMap["business_outlet_image"]?.file_path,
                              )
                            }
                          >
                            Preview the document
                          </button>

                          <div className="licenseExpiryDate">
                            <p>
                              <b>License Expiry Date</b>:{" "}
                              {docMap["business_outlet_image"]
                                .license_expiry_date
                                ? formatDate(
                                    docMap["business_outlet_image"]
                                      .license_expiry_date,
                                  )
                                : "--"}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <>
                          <input
                            type="file"
                            onChange={(e) =>
                              formik.setFieldValue(
                                "business_outlet_image_file",
                                e.target.files[0],
                              )
                            }
                          />

                          {formik.touched.business_outlet_image_file &&
                            formik.errors.business_outlet_image_file && (
                              <div className="text-danger">
                                {formik.errors.business_outlet_image_file}
                              </div>
                            )}
                        </>
                      )}
                    </div>
                    {/* CHECKBOX FOR BOTH EXISTING AND NEWLY SELECTED IMAGE */}
                    <div className="mt-2 ">
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="outlet_verified"
                          checked={formik.values.outlet_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>
                      <div>
                        {(formik.touched.outlet_verified ||
                          formik.submitCount > 0) &&
                          formik.errors.outlet_verified && (
                            <div className="text-danger mt-1">
                              {formik.errors.outlet_verified}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>Udyam Certificate</label>

                      {docMap["udyam_certificate"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["udyam_certificate"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              udyam_certificate: !prev["udyam_certificate"],
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    <div>
                      {docMap["udyam_certificate"]?.file_path &&
                      !reuploadMode["udyam_certificate"] ? (
                        <div>
                          <button
                            type="button"
                            className="preview-button"
                            // onClick={() => {
                            //   setImageUrl(
                            //     docMap["udyam_certificate"].file_path
                            //   );
                            //   setToggleModalOpen(true);
                            // }}
                            onClick={() =>
                              openPreview(
                                docMap["udyam_certificate"]?.file_path,
                              )
                            }
                          >
                            Preview the document
                          </button>

                          <div className="mt-2 d-flex align-items-center gap-2">
                            <input
                              type="checkbox"
                              name="udyam_certificate_verified"
                              checked={formik.values.udyam_certificate_verified}
                              onChange={formik.handleChange}
                            />
                            <span className="textIsverified">Is Verified</span>
                          </div>

                          <div className="licenseExpiryDate">
                            <p>
                              <b>License Expiry Date</b>:{" "}
                              {docMap["udyam_certificate"].license_expiry_date
                                ? formatDate(
                                    docMap["udyam_certificate"]
                                      .license_expiry_date,
                                  )
                                : "--"}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <input
                          type="file"
                          onChange={(e) =>
                            formik.setFieldValue(
                              "udyam_certificate_file",
                              e.target.files[0],
                            )
                          }
                        />
                      )}
                    </div>
                  </div>

                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>Labour License</label>

                      {docMap["labour_license"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["labour_license"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              labour_license: !prev["labour_license"],
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    <div>
                      {docMap["labour_license"]?.file_path &&
                      !reuploadMode["labour_license"] ? (
                        <div>
                          <button
                            type="button"
                            className="preview-button"
                            // onClick={() => {
                            //   setImageUrl(docMap["labour_license"].file_path);
                            //   setToggleModalOpen(true);
                            // }}
                            onClick={() =>
                              openPreview(docMap["labour_license"]?.file_path)
                            }
                          >
                            Preview the document
                          </button>

                          <div className="mt-2 d-flex align-items-center gap-2">
                            <input
                              type="checkbox"
                              name="labour_license_verified"
                              checked={formik.values.labour_license_verified}
                              onChange={formik.handleChange}
                            />
                            <span className="textIsverified">Is Verified</span>
                          </div>

                          <div className="licenseExpiryDate">
                            <p>
                              <b>License Expiry Date</b>:{" "}
                              {docMap["labour_license"].license_expiry_date
                                ? formatDate(
                                    docMap["labour_license"]
                                      .license_expiry_date,
                                  )
                                : "--"}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <input
                          type="file"
                          onChange={(e) =>
                            formik.setFieldValue(
                              "labour_license_file",
                              e.target.files[0],
                            )
                          }
                        />
                      )}
                    </div>
                  </div>
                </>
              ) : null}

              {/* Business Type hospital */}
              {formik.values.business_type === "hospital" ? (
                <>
                  <div className="editWholesaler-field">
                    <div className="doc-label-wrapper">
                      <label>GST Certificate</label>

                      {docMap["gst_certificate"]?.file_path && (
                        <div
                          className={`reupload-icon ${
                            reuploadMode["gst_certificate"] ? "active" : ""
                          }`}
                          onClick={() =>
                            setReuploadMode((prev) => ({
                              ...prev,
                              gst_certificate: !prev.gst_certificate,
                            }))
                          }
                          title="Re-upload document"
                        >
                          ↻
                        </div>
                      )}
                    </div>

                    {docMap["gst_certificate"]?.file_path &&
                    !reuploadMode["gst_certificate"] ? (
                      <div>
                        <button
                          type="button"
                          className="preview-button"
                          // onClick={() => {
                          //   setImageUrl(docMap["gst_certificate"].file_path);
                          //   setToggleModalOpen(true);
                          // }}
                          onClick={() =>
                            openPreview(docMap["gst_certificate"]?.file_path)
                          }
                        >
                          Preview the document
                        </button>

                        <div className="mt-2 d-flex align-items-center gap-2">
                          <input
                            type="checkbox"
                            name="gst_certificate_verified"
                            checked={formik.values.gst_certificate_verified}
                            onChange={formik.handleChange}
                          />
                          <span className="textIsverified">Is Verified</span>
                        </div>

                        <div className="licenseExpiryDate">
                          <p>
                            <b>License Expiry Date</b>:{" "}
                            {docMap["gst_certificate"].license_expiry_date
                              ? formatDate(
                                  docMap["gst_certificate"].license_expiry_date,
                                )
                              : "--"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="file"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "gst_certificate_file",
                            e.target.files[0],
                          )
                        }
                      />
                    )}
                  </div>
                </>
              ) : null}
            </div>
          </div>

          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Retailer Verification</span>
          </div>

          <div className="general-container">
            <div className="general-left">
              {/* IS Registered */}
              <div className="editWholesaler-field">
                <label>IS Registered</label>
                <div
                  className="form-check form-switch"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input form-check-input-verification"
                    checked={formik.values.is_registered}
                    onChange={() => {
                      setToggleTarget({
                        field: "is_registered",
                        currentValue: formik.values.is_registered,
                      });
                      setToggleModalOpenVerification(true);
                    }}
                  />
                </div>
              </div>

              {/* IS Verified */}
              <div className="editWholesaler-field">
                <label>IS Verified</label>
                <div
                  className="form-check form-switch"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input form-check-input-verification"
                    checked={formik.values.is_verified}
                    onChange={() => {
                      setToggleTarget({
                        field: "is_verified",
                        currentValue: formik.values.is_verified,
                      });
                      setToggleModalOpenVerification(true);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="general-right">
              {/* IS Active */}
              <div className="editWholesaler-field">
                <label>IS Active</label>
                <div
                  className="form-check form-switch"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input form-check-input-verification"
                    checked={formik.values.is_active}
                    onChange={() => {
                      setToggleTarget({
                        field: "is_active",
                        currentValue: formik.values.is_active,
                      });
                      setToggleModalOpenVerification(true);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="general-left">
              <div>
                <button
                  type="button"
                  className="whole-btnCancel"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="general-right">
              <div>
                <button
                  type="submit"
                  className="whole-btnUpdate"
                  disabled={loading}
                >
                  {loading ? "Updateing..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Dialog
        open={toggleModalOpenVerification}
        onClose={() => setToggleModalOpenVerification(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Are you sure?
          <IconButton
            aria-label="close"
            onClick={() => setToggleModalOpenVerification(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {toggleTarget && (
            <Typography>
              Do you want to{" "}
              <strong>
                {toggleTarget.currentValue ? "DISABLE" : "ENABLE"}
              </strong>{" "}
              <code>{toggleTarget.field}</code> for this Retailer?
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setToggleModalOpenVerification(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleToggleStatus}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Modal open={toggleModalOpen} onClose={() => setToggleModalOpen(false)}>
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <button
            onClick={() => setToggleModalOpen(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">Preview the document</h3>
          <hr />
          <div style={{ textAlign: "center" }}>
            {imageUrl ? (
              <img
                src={imageUrl || NoImageFound}
                alt="Document"
                onError={(e) => {
                  e.target.onerror = null; 
                  e.target.src = NoImageFound;
                }}
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            ) : (
              <div>No document to display.</div>
            )}
          </div>
          <hr />
        </Box>
      </Modal> */}

      <Modal
        open={toggleModalOpen}
        onClose={() => setToggleModalOpen(false)}
        aria-labelledby="toggle-status-title"
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: 600,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* Close Button */}
          <button
            onClick={() => setToggleModalOpen(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">Preview the document</h3>
          <hr />

          <div style={{ textAlign: "center" }}>
            {/* 🖼 IMAGE PREVIEW */}
            {previewFile.type === "image" && (
              <img
                src={previewFile.url}
                alt="Document"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NoImageFound;
                }}
                style={{
                  width: "100%",
                  maxHeight: "450px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            )}

            {/* 📄 PDF PREVIEW */}
            {previewFile.type === "pdf" && (
              <iframe
                src={previewFile.url}
                title="PDF Preview"
                width="100%"
                height="500px"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            )}

            {/* ❌ UNSUPPORTED */}
            {previewFile.type === "unsupported" && (
              <p style={{ color: "#888" }}>
                Preview not available for this file type.
              </p>
            )}
          </div>

          <hr />

          {/* Optional open in new tab */}
          {previewFile.url && (
            <div style={{ textAlign: "right" }}>
              <a
                href={previewFile.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontWeight: 600, textDecoration: "none" }}
              >
                Open in new tab
              </a>
            </div>
          )}
        </Box>
      </Modal>
    </>
  );
};
